exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error[data-v-5fd9d7a9] {\n  display: block;\n  margin-top: 5px;\n  color: #d23131;\n}", ""]);

// exports
